import React from "react";
import PropTypes from "prop-types";
import { Button, Alert, Box } from "@mui/material";
import * as CONST from "../../Constants";
import * as API from "../../api";
import * as UTILS from "../../../../helpers/Utility";
import Flash from "../../layout/Flash";
import { useHistory } from "react-router";

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  acknowledgedAfterOutcome: PropTypes.bool.isRequired,
  outcomeMessage: PropTypes.string.isRequired,
  response: PropTypes.array.isRequired,
  id: PropTypes.number.isRequired,
};

export const AcknowledgeOutcome = (props) => {
  const [submitting, setSubmitting] = React.useState(false);
  const [flash, setFlash] = React.useState(null);
  const history = useHistory();

  React.useEffect(() => {
    window.location.href.match("outcome") && UTILS.scrollToView("#scroll-to-outcome", 200);
  });

  return (
    <>
      {flash && <Flash flash={flash} handleClose={(e) => setFlash(null)} showButton={false} />}
      {!flash && (<Box p={1} className="bt" id={'scroll-to-outcome'} >
        <Alert severity="info">
          <Box mb={2}>
            <div dangerouslySetInnerHTML={{__html: props.outcomeMessage}}></div>
          </Box>
          <Button
            disabled={submitting || props.acknowledgedAfterOutcome}
            color="inherit"
            size="small"
            onClick={async (e) => {
              setSubmitting(true);
              let res = await API.updateToCpr({
                id: props.id,
                cpr: {
                  in_review: false,
                  responses_attributes: {
                    id: props.response.id,
                    acknowledged: true,
                  },
                },
              });
              if (res.error) {
                setFlash({ ...res });
              } else {
                const notifications = await API.getCprsWithNotifications();
                props.dispatch({
                  type: "set_notifications",
                  payload: notifications,
                });

                if (notifications.cprs && notifications.cprs.find((el) => { return el.id == props.id.toString(); }) && window.location.href.match('requirement') != null) {
                  history.push(`/patient_portal/notifications/${props.id}`)
                }
                setFlash({ success: CONST.FLASH.ACKNOWLEDGE });
              }
            }}
          >
            {CONST.CLICK_TO_ACKNOWLEDGE}
          </Button>
        </Alert>
      </Box>)}
    </>
  );
};
AcknowledgeOutcome.prototype = propTypes;
export default AcknowledgeOutcome;
